var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('koejakson-vaiheet-list',{attrs:{"loading":_vm.loading,"koejaksot":_vm.koejaksot,"component-links":_vm.componentLinks,"vastuuhenkilo":true}})}
var staticRenderFns = []

export { render, staticRenderFns }